import React, { ReactNode, PropsWithChildren } from 'react';

interface Props {
  condition: boolean;
  fallBack?: ReactNode;
}

export const RenderWithCondition = ({ condition, children, fallBack = null }: PropsWithChildren<Props>) => {
  return <>{condition ? children : fallBack}</>;
};
